<template>
    <div id="components-main-layout" v-if="check">
        <a-layout :style="{ zIndex: 1, height: '100%' }">
            <menu_sidebar>这里是sidebar</menu_sidebar>
            <a-layout :style="{ zIndex: 2 }">
                <header_bar>这里是header</header_bar>
                <a-layout-content :style="{padding:'0 20px'}">
                    <div>
                        <a-row :style="{marginTop:'10px',}">
                            <a-breadcrumb>
                                <a-breadcrumb-item>快件报关</a-breadcrumb-item>
                                <a-breadcrumb-item>快件舱单申报</a-breadcrumb-item>
                            </a-breadcrumb>
                        </a-row>
                        <a-row>
                            <div style="background:#FFFFFF;width:100%;margin-top:10px;border-top:4px solid #CCCCCC;padding:10px;">
                                <a-row  :style="{margin:'5px 0 5px 0'}">
                                    <a-col :span="24" align="left"><span style="font-size:18px;">修改密码</span></a-col>
                                </a-row>
                                <a-row>
                                    <a-form-model
                                        :form="form"
                                        :model="json_data"
                                        ref="ruleForm"
                                        :label-col="{ span: 4,offset:1}"
                                        :wrapper-col="{ span: 17 }"
                                        :rules="rules"
                                        :hideRequiredMark = false
                                        :validateOnRuleChange = true
                                    >
                                        <a-col :span="24">
                                            <a-form-model-item label="新密码" prop="password">
                                                <a-input
                                                    type="password"
                                                    placeholder="请填写新密码，6-16位"
                                                    v-model="json_data.password"
                                                />
                                            </a-form-model-item>
                                        </a-col>
                                        <a-col :span="24">
                                            <a-form-model-item label="重复密码" prop="repassword">
                                                <a-input
                                                    type="password"
                                                    placeholder="重复输入密码，6-16位"
                                                    v-model="json_data.repassword" />
                                            </a-form-model-item>
                                        </a-col>
                                        <a-col :span="24" align="right">
                                            <a-button type="primary" @click="onSubmit">保存</a-button>
                                        </a-col>
                                    </a-form-model>
                                </a-row>
                            </div>
                        </a-row>
                    </div>
                </a-layout-content>
            </a-layout>
        </a-layout>
    </div>
</template>

<script>
import menu_sidebar from '../components/menu_sidebar'
import header_bar from '../components/header'
import Cookies from "js-cookie";
import axios from "axios";

export default {
    name: "ChangePassword",
    components:{
        menu_sidebar,
        header_bar,
    },
    data(){
        return{
            check:true,
            current: ['3'],
            openKeys: ['3'],
            form:{},
            rules:{
                password: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { min: 6, max: 32, message: '长度 6-32 位', trigger: 'blur' },
                ],
                repassword: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { min: 6, max: 32, message: '长度 6-32 位', trigger: 'blur' },
                ],
            },
            formLayout: 'horizontal',
            json_data:{
                action:'ChangePassword',
                password:'',
            },
        }
    },
    beforeMount() {
        var token = Cookies.get('Token');
        var json_data = '{"action":"CheckToken","token":"'+token+'"}';
        let self = this;
        axios.post('/api/index.php',json_data)
            .then((response)=> {
                if(response.data.status!=1){
                    self.$router.push({path:'/login'})
                }else{
                    this.check = true;
                    this.json_data.token = token;
                }
            })
            .catch(function (error) { // 请求失败处理
                //console.log(error);
                self.$message.error(error);
            });
        this.$store.commit("sidebar_current", ['3'])
        this.$store.commit("sidebar_openKeys", ['3'])
    },
    methods:{
        onSubmit() {
            let self = this;
            this.$refs.ruleForm.validate(valid => {
                if(valid) {
                    //console.log('ok');
                    this.json_data.password = encodeURI(this.json_data.password);
                    axios.post('/api/index.php',this.json_data)
                        .then((response)=> {
                            if(response.data.status != 1){
                                self.$message.error(response.data.message);
                            }else{
                              self.$message.success(response.data.message);
                            }
                        })
                        .catch(function (error) { // 请求失败处理
                            //console.log(error);
                            self.$message.error(error);
                        });
                } else {
                    //console.log('bad');
                    return false;
                }
            });
        }
    },
}
</script>

<style scoped>
#components-main-layout{height:100%;width:100%;}
#components-main-layout {
    /*text-align: center;*/
}

#components-main-layout .ant-layout-sider {
    background: #E9EEF3;
    color: #fff;
}
#components-main-layout .ant-layout-content {
    background: #E9EEF3;
}
#components-main-layout > .ant-layout {
    margin-bottom: 48px;
}
#components-main-layout > .ant-layout:last-child {
    margin: 0;
}
</style>